import { globalizeSelectors } from '../Utils';
import {
  createArrayDataReducer,
  createSingleDataReducer,
  singleDataType,
} from '../factories/ApiCall';
import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import type {
  MiniGDataAction,
  MiniGDataGenerateResponse,
  MiniGDataState,
  MiniGDataSystem,
} from '../types/MiniGData';
/**
 * Just a simple flag to notify the UI that progress modal needs to be shown!
 */

/*
 * action types
 */

const types = {
  GENERATE_MINI_GDATA: 'MACHINE/GENERATE_MINI_GDATA',
  LIST_MINI_GDATA: 'MACHINE/LIST_MINI_GDATA',
} as const;

/*
 * action creators
 */

const actions = {
  generateMiniGdata: (): MiniGDataAction => ({
    type: types.GENERATE_MINI_GDATA,
  }),
  listGdata: (): MiniGDataAction => ({
    type: types.LIST_MINI_GDATA,
  }),
};

const mountPath = 'minigdata'; // mount point in global state, must match root reducer

/*
 * state shape
 */
const propType = PropTypes.shape({
  generateminigdata: singleDataType,
  listminigdata: singleDataType,
});

/*
 * reducer
 */
const reducer = combineReducers({
  generateminigdata: createSingleDataReducer<MiniGDataGenerateResponse>(
    types.GENERATE_MINI_GDATA
  ),
  listminigdata: createArrayDataReducer<MiniGDataSystem>(types.LIST_MINI_GDATA),
}) as (
  state: MiniGDataState | undefined,
  action: MiniGDataAction
) => MiniGDataState;

/*
 * selectors
 */
const localSelectors = {
  generateminigdata: (
    state: MiniGDataState
  ): MiniGDataState['generateminigdata'] => state.generateminigdata,
  listminigdata: (state: MiniGDataState): MiniGDataState['listminigdata'] =>
    state.listminigdata,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export {
  types as actionTypes,
  actions as default,
  propType,
  selectors,
  reducer,
};
